<template>
  <form class="personal-form" @submit="submit" v-if="me">
    <div class="but-profile-logout">
      <a href="/?logout=yes">
        <img src="/upload/exit.png" alt="logout"/>
      </a>
    </div>
    <div v-if="saved" class="alert alert-success">
      Данные сохранены
    </div>
    <div v-if="error" class="alert alert-danger" v-html="error"></div>
    <text-input name="LAST_NAME" label="Фамилия" :value="me.LAST_NAME"></text-input>
    <text-input name="NAME" label="Имя" :value="me.NAME"></text-input>
    <text-input name="SECOND_NAME" label="Отчество" :value="me.SECOND_NAME"></text-input>
    <text-input name="LOGIN" label="Логин" :required="true" :value="me.LOGIN"></text-input>
    <text-input type="email" name="EMAIL" label="Эл. почта" :required="true" :value="me.EMAIL"></text-input>
    <phone-input name="PERSONAL_PHONE" label="Телефон" :value="me.PERSONAL_PHONE"></phone-input>
    <date-input name="PERSONAL_BIRTHDAY" label="Дата рождения" :value="me.PERSONAL_BIRTHDAY"></date-input>
    <div class="btn-result-wrapper">
      <btn :loading="loading"></btn>
      <btn
        :loading="loading"
        title="Удалить профиль"
        style="background: #ff4242; border-color: #ff4242"
        @click="removeAccount"></btn>
    </div>
  </form>
</template>

<script>
  import BaseInput from '../../BaseInput'
  import TextInput from '../../form/TextInput'
  import PhoneInput from '../../form/PhoneInput'
  import DateInput from '../../form/DateInput'
  import Btn from '../../form/Btn'
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import { removeAccount } from '../../../api/user'

  export default {
    name: 'personal-data',
    components: {Btn, DateInput, PhoneInput, TextInput, BaseInput},
    data () {
      return {
        saved: false,
        error: '',
        loading: false
      }
    },
    computed: {
      ...mapGetters('user', [
        'me'
      ])
    },
    methods: {
      async submit ($event) {
        $event.preventDefault()
        this.loading = true
        try {
          await axios.post('personal/data', new FormData($event.target))

          this.saved = true
          setTimeout(() => {
            this.saved = false
          }, 5000)

          this.$store.dispatch('user/fetchMe')
        } catch (e) {
          this.error = e.response.data.error
        }

        this.loading = false
      },
      async removeAccount ($event) {
        $event.preventDefault()
        this.loading = true
        try {
          await removeAccount()
        } finally {
          window.location.href = '/'
          this.loading = false
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .btn-result-wrapper {
    display: flex;
    justify-content: space-between;
  }
  .but-profile-logout {
    position: absolute;
    right: 0;
    top: 60px;
    transition: all 600ms ease;
    &:hover {
      transform: rotate(-30deg);
    }
  }

  @media (max-width: 768px) {
    .btn-result-wrapper {
      flex-direction: column;

      >button:first-child {
        margin-bottom: 15px;
      }
    }
  }

  .personal-form {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Personal/PersonalProfile/PersonalData.vue